(function () {
  'use strict';
  const MAX_AGE = 36 * 60 * 60 * 1000;
  function stockState(snapshot, variantId, mode, expectedCount, now = Date.now()) {
    const checked = Date.parse(snapshot?.checked_at);
    const unknown = { status: 'unknown' };
    if (snapshot?.version !== 1 || !Number.isFinite(checked) || now < checked || now - checked > MAX_AGE) return unknown;
    const rows = snapshot.variants || {};
    const valid = row => row && Number.isInteger(row.quantity) && row.quantity >= 0;
    if (mode === 'summary') {
      const known = Object.values(rows).filter(valid);
      if (known.some(row => row.quantity > 0)) return { status: 'in-stock', checked, kind: snapshot.kind, quantity: known.length === expectedCount ? known.reduce((sum,row) => sum + row.quantity, 0) : undefined };
      if (known.length === expectedCount && known.length > 0) return { status: 'preorder', checked, kind: snapshot.kind };
      return unknown;
    }
    const row = rows[String(variantId)];
    if (!valid(row)) return unknown;
    const arrival = /^\d{4}-\d{2}-\d{2}$/.test(row.warehouse_arrival || '') && Date.parse(row.warehouse_arrival + 'T23:59:59Z') >= now ? row.warehouse_arrival : null;
    return { status: row.quantity > 0 ? 'in-stock' : 'preorder', quantity: row.quantity, arrival, checked, kind: snapshot.kind };
  }
  function cardStockState(snapshot, variants, now = Date.now()) {
    const unknown = {status:'unknown'};
    if (!Array.isArray(variants) || !variants.length || variants.some(row => !row || !['string','number'].includes(typeof row.id) || !String(row.id).length)) return unknown;
    const ids = variants.map(row => String(row.id));
    if (new Set(ids).size !== ids.length) return unknown;
    const validQuantity = quantity => Number.isSafeInteger(quantity) && quantity >= 0;
    const checked = Date.parse(snapshot?.checked_at);
    let supplierEmpty = false;
    const fresh = snapshot?.version === 1 && Number.isFinite(checked) && now >= checked && now - checked <= MAX_AGE;
    if (fresh && snapshot.variants && typeof snapshot.variants === 'object' && !Array.isArray(snapshot.variants)) {
      const rows = variants.map(variant => ({...variant, quantity:snapshot.variants[String(variant.id)]?.quantity}));
      const valid = rows.filter(row => validQuantity(row.quantity));
      const available = valid.filter(row => row.quantity > 0);
      const complete = valid.length === variants.length && Object.keys(snapshot.variants).length === variants.length;
      if (available.length) {
        const quantity = complete ? valid.reduce((sum,row) => sum + row.quantity,0) : undefined;
        return {status:'in-stock',source:'supplier',checked,quantity:Number.isSafeInteger(quantity) ? quantity : undefined,options:available.map(row => row.title)};
      }
      if (complete) supplierEmpty = true;
    }
    const tracked = variants.filter(row => row.tracked === true && Number.isSafeInteger(row.quantity));
    const available = tracked.filter(row => row.quantity > 0);
    if (available.length) {
      const quantity = tracked.length === variants.length ? available.reduce((sum,row) => sum + row.quantity,0) : undefined;
      return {status:'in-stock',source:'owned',quantity:Number.isSafeInteger(quantity) ? quantity : undefined,options:available.map(row => row.title)};
    }
    if (supplierEmpty) return {status:'preorder',source:'supplier',checked};
    if (!snapshot && tracked.length === variants.length && tracked.every(row => row.policy === 'deny')) return {status:'out-of-stock',source:'owned'};
    return unknown;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { stockState, cardStockState, MAX_AGE };
  if (typeof document === 'undefined') return;
  const views = new Map();
  const format = (text, values) => Object.entries(values).reduce((s, [k,v]) => s.replaceAll('__' + k.toUpperCase() + '__', String(v)), text || '');
  const dateText = value => new Intl.DateTimeFormat('en-GB', { day:'numeric', month:'short', year:'numeric', timeZone:'Europe/London' }).format(new Date(value));
  function formProperty(form, name, value) {
    if (!form) return;
    let input = form.querySelector('[data-stock-property="' + name + '"]');
    if (!input) {
      input = document.createElement('input'); input.type = 'hidden';
      input.name = 'properties[' + name + ']'; input.dataset.stockProperty = name; form.append(input);
    }
    input.value = value;
    input.disabled = !value;
  }
  function updateView(el, data) {
    const wrap = el.closest('[data-htl-purchase], [data-product-form]');
    const variantId = wrap?.querySelector('[data-enquiry-variant]')?.selectedOptions[0]?.dataset.variantId || wrap?.querySelector('select[name="id"]')?.value || el.dataset.defaultVariant;
    const card = el.dataset.mode === 'card';
    const state = card ? cardStockState(data.snapshot, data.variants) : stockState(data.snapshot, variantId, el.dataset.mode, Number(el.dataset.variantCount));
    const key = JSON.stringify([state,variantId]);
    if (key === data.last) return;
    data.last = key;
    const summary = el.dataset.mode === 'summary' || card, copy = data.copy;
    let title = copy.check, note = copy.unknown_note;
    if (state.status === 'in-stock') {
      title = summary ? state.quantity === 1 ? copy.summary_last : state.quantity <= 3 ? format(copy.summary_low, {count:state.quantity}) : copy.summary_stock : state.quantity === 1 ? copy.last_one : format(state.quantity <= 3 ? copy.low_stock : copy.in_stock, {count:state.quantity});
      note = summary ? state.kind === 'hot-tub' ? copy.summary_delivery_hot : copy.summary_delivery_swim : state.kind === 'hot-tub' ? copy.delivery_hot : copy.delivery_swim;
    } else if (state.status === 'preorder') {
      title = summary ? copy.summary_preorder : copy.preorder;
      note = summary ? copy.summary_note : state.arrival ? format(copy.arrival, {date:dateText(state.arrival + 'T12:00:00Z')}) : copy.undated;
    }
    if (summary && state.status === 'unknown') note = copy.summary_unknown;
    if (card) {
      if (state.status === 'in-stock') {
        title = state.quantity === 1 ? copy.card_last : state.quantity === 2 ? format(copy.card_low,{count:2}) : Number.isSafeInteger(state.quantity) ? format(copy.card_in_stock,{count:state.quantity}) : copy.summary_stock;
        const source = state.source === 'supplier' ? copy.card_supplier : copy.card_owned;
        const options = state.options || [];
        const detail = options.length > 1 ? format(copy.card_options,{count:options.length}) : options[0] === 'Default Title' ? '' : options[0] || '';
        note = source + (detail ? ' · ' + detail : '');
      } else if (state.status === 'preorder') {
        title = copy.card_preorder;
        note = copy.card_supplier + ' · ' + copy.summary_note;
      } else if (state.status === 'out-of-stock') {
        title = copy.card_out;
        note = copy.card_unknown;
      } else {
        title = copy.check;
        note = copy.card_unknown;
      }
      el.dataset.urgency = state.status === 'in-stock' && (state.quantity === 1 || state.quantity === 2) ? 'low' : '';
    }
    el.dataset.status = state.status;
    el.dataset.quantity = state.quantity === undefined ? '' : String(state.quantity);
    el.querySelector('[data-stock-title]').textContent = title;
    el.querySelector('[data-stock-note]').textContent = note;
    const help = el.querySelector('.htl-stock__help');
    if (help) help.textContent = (state.status === 'in-stock' && state.quantity === 1 ? copy.last_help : copy.help) + '';
    el.querySelector('[data-stock-checked]').textContent = state.checked ? format(card ? copy.card_check_date : summary ? copy.summary_checked : copy.checked, {date:dateText(state.checked)}) : '';
    if (!summary && wrap && !wrap.hasAttribute('data-contact-first')) {
      const deposit = wrap.querySelector('.htl-deposit-form');
      const button = deposit?.querySelector('button[type="submit"]');
      if (button) button.textContent = format(state.status === 'preorder' ? copy.preorder_deposit : copy.reserve, {amount:'99'});
      const buy = wrap.querySelector('.add_to_cart .text');
      if (buy) {
        if (!buy.dataset.stockOriginal) buy.dataset.stockOriginal = buy.textContent;
        buy.textContent = state.status === 'preorder' ? copy.preorder_full : buy.dataset.stockOriginal;
      }
      [wrap.querySelector('form.shopify-product-form'), deposit].forEach(form => {
        formProperty(form,'Supply status',state.status === 'preorder' ? 'Pre-order — delivery to be confirmed' : state.status === 'in-stock' ? 'Supplier stock — allocation to be confirmed' : 'Availability to be confirmed');
        formProperty(form,'Stock checked',state.checked ? new Date(state.checked).toISOString() : '');
        formProperty(form,'Estimated supplier warehouse arrival',state.status === 'preorder' ? state.arrival || '' : '');
      });
    }
  }
  function init() {
    document.querySelectorAll('[data-htl-stock]').forEach(el => {
      if (views.has(el)) return;
      try {
        const data = {snapshot:JSON.parse(el.dataset.snapshot),copy:JSON.parse(el.querySelector('[data-stock-copy]').textContent),variants:JSON.parse(el.querySelector('[data-card-stock-variants]')?.dataset.cardStockVariants || '[]')};
        views.set(el,data); updateView(el,data);
      } catch (_) { /* Leave the safe availability-check message visible. */ }
    });
  }
  function refresh() {
    views.forEach((data, el) => { if (el.isConnected) updateView(el,data); else views.delete(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('change', () => setTimeout(refresh, 50));
  document.addEventListener('submit', refresh, true);
  document.addEventListener('click', e => { if (e.target.closest('.add_to_cart')) refresh(); }, true);
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(() => { init(); }).observe(document.documentElement, {childList:true,subtree:true});
  // Some legacy selectors change their hidden variant ID without a native change event.
  setInterval(refresh,1000);
})();
